import { render, staticRenderFns } from "./BatchConfirm.vue?vue&type=template&id=e6a09448"
import script from "./BatchConfirm.vue?vue&type=script&lang=js"
export * from "./BatchConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports